import React, { useMemo } from 'react';
import Box from '@rexlabs/box';
import {
  TableProvider,
  Table,
  SimplePagination,
  TextCell,
  useTableQuery,
  DateCell
} from '@rexlabs/table';
import { Link } from '@rexlabs/react-whereabouts';
import { Heading, Body } from '@rexlabs/text';
import { PrimaryButton } from '@rexlabs/button';
import ROUTES from 'src/routes/app';
import { syncsQuery } from 'data/queries/syncs';
import Screen from 'view/components/screen';
import { api } from 'utils/api-client';
import DurationCell from 'view/components/table/custom-cells/duration';

function SyncsList() {
  const tableQuery = useMemo(() => {
    return syncsQuery;
  }, []);

  const { getTableProps: getTableQueryProps } = useTableQuery({
    getQuery: () => tableQuery
  });

  const runSyncNow = (id) => {
    return api.post(`/syncs/${id}/run`);
  };

  const getActionMenuItems = ({ item }) => {
    return [
      {
        label: 'Sync now',
        onClick: () => runSyncNow(item?.id)
      }
    ];
  };

  const columns = [
    {
      id: 'label',
      width: 'auto',
      Header: 'Label',
      Cell: TextCell
    },
    {
      id: 'source_name',
      width: 'auto',
      Header: 'Source',
      Cell: TextCell
    },
    {
      id: 'sync_frequency',
      width: 'auto',
      Header: 'Frequency',
      Cell: DurationCell
    },
    {
      id: 'last_run',
      width: 'auto',
      Header: 'Last Run',
      cellProps: {
        format: 'MMM DD, h:mma'
      },
      Cell: DateCell
    }
  ];

  return (
    <Screen>
      <Heading>Syncs</Heading>
      <Box
        justifyContent='space-between'
        alignItems='center'
        pt={'1.6rem'}
        pb={'1.6rem'}
      >
        <Link to={ROUTES.SYNCS.CREATE}>
          {({ onClick }) => (
            <PrimaryButton onClick={onClick}>Add sync</PrimaryButton>
          )}
        </Link>
      </Box>
      <Body grey>Create/edit data syncs</Body>
      <TableProvider
        columns={columns}
        {...getTableQueryProps()}
        getActionMenuItems={getActionMenuItems}
      >
        <Table />
        <SimplePagination />
      </TableProvider>
    </Screen>
  );
}

export default SyncsList;
